import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import { FaFacebookMessenger, FaWhatsapp, FaMapMarkerAlt, FaMapMarkedAlt } from "react-icons/fa";
import { IoIosMail } from "react-icons/io";

import { sendEmailToProlitigio } from "./../../ses_sendemail";

const Contact = (props) => {
	const [contactFormPopup, setContactFormPopup] = useState({
		show: false,
		showConfirm: false,
	});

	const [contactForm, setContactForm] = useState({
		nombre: "",
		correo: "",
		mensaje: "",
	});

	const openFacebookChat = () => {
		window.open("http://m.me/PROLITIGIO", "_blank");
	};

	const openWhatsappChat = () => {
		window.open("https://wa.me/qr/Y652BEQ7UDKNE1", "_blank");
	};

	const openGoogleMaps = () => {
		window.open(
			"https://www.google.com/maps/place/Abogados+Penalistas+-+PROLITIGIO+S.C./@32.6614374,-115.4803656,20z/data=!4m14!1m7!3m6!1s0x80d77114d035ca0d:0x795d0c19fc7e1ed9!2sAbogados+Penalistas+-+PROLITIGIO+S.C.!8m2!3d32.6614338!4d-115.4802514!16s%2Fg%2F11h_vxd_n9!3m5!1s0x80d77114d035ca0d:0x795d0c19fc7e1ed9!8m2!3d32.6614338!4d-115.4802514!16s%2Fg%2F11h_vxd_n9?entry=ttu&g_ep=EgoyMDI2MDQwOC4wIKXMDSoASAFQAw%3D%3D",
			"_blank",
		);
	};

	const openEmailPopup = () => {
		setContactFormPopup({ show: true });
	};

	const sendEmail = () => {
		sendEmailToProlitigio(
			`Prolitigio - Contacto: ${contactForm.nombre}`,
			<div className="d-flex flex-column">
				<h1>Este es un mensaje automatico de www.prolitigio.org</h1>
				<div className="mt-3">
					{`Nombre: ${contactForm.nombre}`}
					<br />
					{`Correo: ${contactForm.correo}`}
					<br />
					{`Mensaje: ${contactForm.mensaje}`}
				</div>
			</div>,
			(data) => {
				setContactFormPopup({ show: false, showConfirm: true });
			},
			(error) => {
				alert("Hay un problema con este servicio, por favor intentelo más tarde.");
			},
		);
	};

	return (
		<div className="bg-blue p-4" id={props.id}>
			<Container>
				<>
					<div className="d-flex flex-column flex-md-row justify-content-center">
						<div className="text-left py-3 pr-md-3">
							<div>
								<FaMapMarkerAlt style={{ marginBottom: "5px", marginRight: "10px", width: "20px", height: "20px" }} />
								<span className="text-uppercase font-weight-bold">Ubicación</span>
							</div>
							<div className="row-location pl-4">
								<span>Sebastián Lerdo de Tejada 368 interior 2</span>
								<span>Colonia segunda sección, Mexicali BC</span>
								<span>México</span>
								<div className="d-flex flex-column flex-md-row justify-content-center">
									<Button
										style={{ marginTop: "20px", marginLeft: "-14px" }}
										className="text-uppercase font-weight-bold text-blue"
										variant="light"
										onClick={() => openGoogleMaps()}>
										<FaMapMarkedAlt
											style={{ marginRight: "10px", marginBottom: "5px", width: "20px", height: "20px" }}
										/>
										<span>Mostrar Mapa</span>
									</Button>
								</div>
							</div>
						</div>
						<div className="bg-white m-3 d-none d-md-block" style={{ minWidth: "1px", minHeight: "1px" }} />
						<div className="text-left py-3 pl-md-3">
							<div className="d-flex flex-column justify-content-start">
								<span className="text-uppercase font-weight-bold">Contacto</span>
								<span style={{ maxWidth: "330px" }}>
									Envíanos tus dudas, pronto nos pondremos en contacto contigo para brindarte una asesoría.
								</span>
							</div>
							<div className="d-flex flex-column flex-md-row justify-content-center" style={{ marginTop: "37px" }}>
								<Button
									className="text-uppercase font-weight-bold text-blue m-2"
									variant="light"
									onClick={() => openFacebookChat()}>
									<FaFacebookMessenger
										style={{ marginRight: "10px", marginBottom: "3px", width: "20px", height: "20px" }}
									/>
									<span>Facebook</span>
								</Button>
								<Button
									className="text-uppercase font-weight-bold text-blue m-2"
									variant="light"
									onClick={() => openWhatsappChat()}>
									<FaWhatsapp style={{ marginRight: "10px", marginBottom: "3px", width: "20px", height: "20px" }} />
									<span>Whatsapp</span>
								</Button>
							</div>
						</div>
					</div>
					{contactFormPopup.show ? (
						<>
							<div className="modal-backdrop fade show"></div>
							<div className="modal fade show d-block" id="contact-popup">
								<div className="modal-dialog modal-dialog-centered">
									<div className="modal-content">
										<div className="modal-header">
											<h4 className="modal-title text-primary">CONTACTO</h4>
											<button type="button" className="close" onClick={() => setContactFormPopup({ show: false })}>
												&times;
											</button>
										</div>
										<div className="modal-body" style={{ color: "black" }}>
											<div className="d-flex flex-column justify-content-center align-items-center">
												<span className="mb-3">Tu dirección de correo electrónico no será publicada</span>
												<span className="text-muted">Los campos obligatorios están marcados con *</span>
												<div className="col-12 mb-4">
													<input
														placeholder="Nombre Completo *"
														type="text"
														className="form-control form-control-sm mb-2"
														value={contactForm.nombre}
														onChange={(e) => {
															const value = e.target.value;
															setContactForm({ ...contactForm, nombre: value });
														}}
													/>
													<input
														placeholder="Correo electrónico *"
														type="text"
														className="form-control form-control-sm mb-2"
														value={contactForm.correo}
														onChange={(e) => {
															const value = e.target.value;
															setContactForm({ ...contactForm, correo: value });
														}}
													/>
													<textarea
														placeholder="Escribe aquí tu duda, comentario o sugerencia *"
														type="text"
														className="form-control form-control-sm"
														style={{ height: "110px", resize: "none" }}
														value={contactForm.mensaje}
														onChange={(e) => {
															const value = e.target.value;
															setContactForm({ ...contactForm, mensaje: value });
														}}
													/>
												</div>
												<button
													disabled={
														contactForm.correo.length < 5 ||
														contactForm.nombre.length < 5 ||
														contactForm.mensaje.length < 5
													}
													type="submit"
													className="text-uppercase btn btn-primary mb-3"
													onClick={() => sendEmail()}>
													Enviar
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</>
					) : null}
					{contactFormPopup.showConfirm ? (
						<div
							className="modal-backdrop"
							style={{ opacity: 1, background: "rgba(0, 0, 0, 0.5)" }}
							onClick={() => setContactFormPopup({ show: false })}>
							<div class="toast" style={{ opacity: "1", float: "right", margin: "20px 40px", backgroundColor: "white" }}>
								<div class="toast-header">
									<strong class="mr-auto text-primary">Mensaje Enviado</strong>
									<button type="button" class="ml-2 mb-1 close" onClick={() => setContactFormPopup({ show: false })}>
										&times;
									</button>
								</div>
								<div class="toast-body" style={{ color: "black" }}>
									¡Gracias por contactarnos! Nuestro personal te contactará en breve.
								</div>
							</div>
						</div>
					) : null}
				</>
			</Container>
		</div>
	);
};

export default Contact;
